module.exports = __webpack_public_path__ + "assets/images/page-book_4ea964a070993ec52ccedfc90630d43c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/page-book.png
// module id = 185
// module chunks = 0